import {defineStore} from "pinia";
import {Ref, ref} from "vue";
import {IPanel, IPanelKey} from "@/features/chat/chat.types";
import router from "@/router";
import {ITableItem} from "@/types/table";
import {ICountFilter, IFilter} from "@/types/main";
import {IProfile} from "@/features/auth/auth.types";
import {authService} from "@/features/auth/auth.service";
import {chatService} from "@/features/chat/chat.service";
import {statsService} from "@/features/stats/stats.service";

export const useStatsStore = defineStore("stats", () => {
    const panels = ref<IPanel>({
        allMessages: true,
        text: false,
        call: false,
        voice: false,
        photo: false,
        allErrors: false,
        replyTime: false,
        unanswered: false,
        deleted: false,
        edited: false,
    });

    function selectPanel(type: IPanelKey) {
        if (type === "allMessages") {
            for (const key of Object.keys(panels.value) as (keyof IPanel)[]) {
                panels.value[key] = false;
            }

            panels.value[type] = true;
        } else {
            if (panels.value[type]) {
                panels.value[type] = false;

                let isThereTrue: boolean = false;
                for (const key of Object.keys(panels.value) as (keyof IPanel)[]) {
                    if (panels.value[key]) {
                        isThereTrue = true;
                    }
                }

                if (!isThereTrue) {
                    panels.value.allMessages = true;
                }
            } else {
                panels.value.allMessages = false;
                panels.value[type] = !panels.value[type];
            }

            if (type === "allErrors") {
                for (const key of Object.keys(panels.value) as (keyof IPanel)[]) {
                    if (key !== "allErrors" && key !== "allMessages") {
                        panels.value[key] = false;
                    }
                }
            } else if (
                type === "replyTime" ||
                type === "unanswered" ||
                type === "deleted" ||
                type === "edited" ||
                type === "text" ||
                type === "call" ||
                type === "voice" ||
                type === "photo"
            ) {
                panels.value.allErrors = false;
            }
        }
    }

    async function getStats(filter: ICountFilter, loading: Ref) {
        try {
            loading.value = true
            const {data} = await statsService.getCounts(filter);
            return data
        } finally {
            loading.value = false
        }
    }

    function setDefaultPanels() {
        panels.value = {
            allMessages: true,
            text: false,
            call: false,
            voice: false,
            photo: false,
            allErrors: false,
            replyTime: false,
            unanswered: false,
            deleted: false,
            edited: false,
        }
    }

    return {panels, selectPanel, getStats, setDefaultPanels};
});
